import React, { useContext } from 'react';

import {
  UserContext,
  actionTypes,
} from 'containers/pages/ManageUsers/usersContext';
import {
  DispatchChimeContext,
  actionTypes as chimeActionTypes,
} from 'containers/pages/ManageUsers/ChimeDrawer/context';

import { UserActions } from '../userActions';

const RowAction = ({
  user,
  hasVoiceIdentity,
  hasVoiceLicense,
  hasChimeIdentity,
  voiceAction,
  onEditUser,
}) => {
  const chimeDispatch = useContext(DispatchChimeContext);
  const { dispatch } = useContext(UserContext);

  const noop = () => null;

  const setEditMode = () => {
    chimeDispatch({
      type: chimeActionTypes.SET_CHIME_DRAWER_EDIT_MODE,
      user,
    });
  };

  const setCreateMode = () => {
    chimeDispatch({
      type: chimeActionTypes.SET_CHIME_DRAWER_CREATE_MODE,
      user,
    });
  };

  const chimeActionHandler = (state, rowUser) => {
    switch (state) {
      case 'settings':
        setEditMode(rowUser);
        break;
      case 'setup':
        setCreateMode();
        break;
      default:
        setCreateMode();
        break;
    }
  };

  return (
    <UserActions
      user={user}
      hasVoiceIdentity={hasVoiceIdentity}
      hasVoiceLicense={hasVoiceLicense}
      hasChimeIdentity={hasChimeIdentity}
      editAction={() => {
        dispatch({
          type: actionTypes.SET_EDIT_USER,
          user,
        });
        onEditUser();
      }}
      voiceAction={voiceAction}
      chimeAction={chimeActionHandler}
      emailSetupAction={noop}
      emailSettingsAction={noop}
      chatSettingsAction={noop}
      smsSettingsAction={noop}
      deleteUserAction={noop}
    />
  );
};

export default RowAction;
